import { MediaRefImage } from '@/components/media-ref-image';
import type { MediaRef } from '@/lib/media';

/** Small rounded leading tile for a table row: the asset image, or its initial. */
export function RowThumb({ media, label }: { media?: MediaRef | null; label: string }) {
  return (
    <div className="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-md bg-muted font-medium text-xs">
      {media ? (
        <MediaRefImage media={media} className="h-full w-full" />
      ) : (
        label.slice(0, 1).toUpperCase()
      )}
    </div>
  );
}
